<template>
  <router-view />
</template>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  // box-sizing: border-box;
  // font-family: "Karla", sans-serif;
}

</style>
